NumbersEditor.controller('MasterController', [
    '$scope', '$location', 'authFactory', '$http', '$timeout', 'appInfoFactory', 'localStorageService',
    function ($scope, $location, authFactory, $http, $timeout, appInfoFactory, localStorageService) {

        var authenticationData = authFactory.GetAuthenticationData();
        if (authenticationData) {
            $scope.username = authenticationData.username;
            $scope.isAdmin = authenticationData.isAdmin;
        }

        window.setInterval(function () {
            checkForRefreshToken();
        }, 30000);

        $scope.logOut = function () {
            authFactory.logOut();
            $location.path('login');
        };

        $scope.startClock = function () {
            var setTime = function () {
                appInfoFactory.getDateTime()
                    .success(function (today) {
                        $scope.clock = new Date(JSON.parse(today));
                        $timeout(function () { tickSeconds(1) }, 1000);
                    }).error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            }

            var tickSeconds = function (tickedSeconds) {
                if (tickedSeconds > 9) {
                    setTime();
                } else {
                    $scope.clock.setSeconds($scope.clock.getSeconds() + 1);
                    $timeout(function () { tickSeconds(tickedSeconds + 1) }, 1000);
                }
            }

            $scope.clock = "Loading the clock...";
            setTime();
        }

        checkForRefreshToken = function () {
            var authRefresh = localStorage.getItem("authenticationRefreshData");
            var activityData = localStorage.getItem("activity");
            if (authRefresh != null) {
                var authRefreshData = JSON.parse(authRefresh);
                var expiresin = parseInt(authRefreshData.expires_in);
                var timestamp = new Date(authRefreshData.timestamp);
                var currenttime = new Date();
                var secondspassed = (currenttime.getTime() - timestamp.getTime()) / 1000;
                var timeleft = expiresin - secondspassed;

                if (timeleft < 120) {  // If there's only 2 minutes left, renew the token
                    // Check if there's activity
                    var hasactivity = false;
                    if (activityData != null) {
                        var activityDate = new Date(activityData);
                        var activitysecondspassed = (currenttime.getTime() - activityDate.getTime()) / 1000;
                        if (activitysecondspassed < expiresin - 30) {
                            hasactivity = true
                        }
                    }
                    if (hasactivity) {
                        renewToken();
                    }
                }
            }
        }

        renewToken = function () {
            authFactory.getCreds()
                .success(function (credresponse) {
                    authFactory.login(credresponse.Credentials)
                        .success(function (response) {
                            authFactory.getUserWithCreds(response.access_token, credresponse.Credentials)
                                .success(function (res) {
                                    localStorageService.storeUserData(response, self.userName, res.IsAdmin, res.IsTechSuper, res.CredsKey);
                                })
                                .error(function (err) {
                                    $.message("Could not renew login token", MessageType.Error);
                                });

                        }).error(function (err) {
                            $.message("Could not renew login token", MessageType.Error);
                        });
                }).error(function (err) {
                    $.message("Could not renew login token", MessageType.Error);
                });
        }
    }
]);